export {
    ClassTimetable as default,
    classTimetableServerSideProps as getServerSideProps,
} from '../../../../compositions';
